export default [
    {
        id: 1,
        code_bde: 1,
        name_ca: 'Nova',
        name_en: 'New',
        name_es: 'Nueva',
    },
    {
        id: 2,
        code_bde: 2,
        name_ca: 'Bona',
        name_en: 'Good',
        name_es: 'Buena',
    },
    {
        id: 3,
        code_bde: 3,
        name_ca: 'Regular / Mitjana',
        name_en: 'Regular / Average',
        name_es: 'Regular / Media',
    },
    {
        id: 4,
        code_bde: 4,
        name_ca: 'Dolenta',
        name_en: 'Bad',
        name_es: 'Mala',
    },
    {
        id: 5,
        code_bde: 5,
        name_ca: 'No comprovat',
        name_en: 'Not checked',
        name_es: 'No comprobado',
    }
]



// WEBPACK FOOTER //
// ./src/options/conservation_statuses.js